export type descriptionMultiCols = {
  cols: number
  content: string[]
}

export enum Color {
  yellow,
  orange,
  blue
}
